import CustomerType from "./actionTypes"

const INIT_STATE = {
  pagesOther: {
    loading: true,
    data: {}
  },
  detailOther: {
    loading: true,
    data: {}
  },
  savedOther: {
    loading: false
  },
  otherHistory: {
    loading: true,
    data: {}
  },
  pagesIgarashi: {
    loading: true,
    data: {}
  },
  detailIgarashi: {
    loading: false,
    data: {}
  },
  savedIgarashi: {
    loading: false
  },
  igarashiHistory: {
    loading: true,
    data: {}
  }
}

const Customer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // OTHER
    case CustomerType.GET_OTHER_CUSTOMER_PAGES_SUCCESS:
      return {
        ...state,
        pagesOther: action.payload,
      }
    case CustomerType.GET_DETAIL_OTHER_CUSTOMER_BY_ID_SUCCESS:
      return {
        ...state,
        detailOther: action.payload,
      }

    case CustomerType.PUT_OTHER_CUSTOMER_SUCCESS:
      return {
        ...state,
        savedOther: action.payload,
      }

    case CustomerType.POST_OTHER_CUSTOMER_SUCCESS:
      return {
        ...state,
        savedOther: action.payload,
      }
    case CustomerType.GET_OTHER_CUSTOMER_HISTORIES_PAGES_SUCCESS:
      return {
        ...state,
        otherHistory: action.payload,
      }

    // IGARASHI
    case CustomerType.GET_IGARASHI_CUSTOMER_PAGES_SUCCESS:
      return {
        ...state,
        pagesIgarashi: action.payload,
      }
    case CustomerType.GET_DETAIL_IGARASHI_CUSTOMER_BY_ID_SUCCESS:
      return {
        ...state,
        detailIgarashi: action.payload,
      }

    case CustomerType.PUT_IGARASHI_CUSTOMER_SUCCESS:
      return {
        ...state,
        savedIgarashi: action.payload,
      }

    case CustomerType.POST_IGARASHI_CUSTOMER_SUCCESS:
      return {
        ...state,
        savedIgarashi: action.payload,
      }
    case CustomerType.GET_IGARASHI_CUSTOMER_HISTORIES_PAGES_SUCCESS:
      return {
        ...state,
        igarashiHistory: action.payload,
      }

    default:
      return state
  }
}

export default Customer
